<template>
    <Card >
      <AjaxForm v-if="tr" :route="'admin/rejectOfferReason/Edit/'+id">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="عنوان..."
                         label="عنوان"
                         type="text"
                         :model-value="tr.title"
                         name="title"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput type="select" label="نوع" v-model="typeUser" select-label="title" :select-options="options"
                         name="type" placeholder="نوع کاربر را انتخاب کنید" reduce_select="value" />
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="توضیحات..."
                         label="توضیحات"
                         :model-value="tr.description"
                         type="textarea"
                         name="description"></CustomInput>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button class="btn btn-info btn-block" type="submit">ویرایش اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
      <div v-else-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import vSelect from 'vue-select'
import {mapActions} from "vuex";
export default {
  name: "rejectOfferReasonEdit",
  components: {CustomInput, AjaxForm, Card, MasterLayout,vSelect},
  data(){
    return{
      id : this.$route.params.id,
      tr : null,
      error : null,
      typeUser : null,
      options : [
        {value : 'seller',title : 'فروشنده'},
        {value : 'buyer',title : 'خریدار'},
      ]
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ویرایش دلیل رد کردن پیشنهاد');
    this.setShowHead(true);
    this.initPage();
  },
  methods :{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.error = null;
      this.tr = null;
      this.id = this.$route.params.id;
      const result = await AppApi.getRejectOfferReasonInfo(this.id);
      if (result.ok)
      {
        this.tr = result.tr;
        if (this.tr.type === 'seller')
          this.typeUser = {value : 'seller',title : 'فروشنده'};
        else
          this.typeUser = {value : 'buyer',title : 'خریدار'};
      }
      else
      {
        this.error = result.error;
      }
    }
  }
}
</script>

<style scoped>

</style>